//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
var BASE_URL = "/prototype/properties/reports";
import { createExport } from "@/mixins/createExport";

export default {
  mixins: [createExport],
  data: function data() {
    var $el = this;
    return {
      loading: true,
      start_date: '',
      end_date: '',
      items: [],
      exportExcel: false,
      sortBy: 'user.name',
      sortDirection: 'ASC'
    };
  },

  props: ["reportId", "reportType", "reportTable"],
  created: function created() {
    var _this = this;

    Event.$on("report", function () {
      _this.$children[0].showModal = true;
      _this.load();
    });

    this.start_date = this.getStartDate();
    this.end_date = this.getEndDate();
  },
  beforeDestroy: function beforeDestroy() {
    Event.$off("report");
  },
  mounted: function mounted() {
    var $el = this;
    this.getReport();
  },

  methods: {
    getStartDate: function getStartDate() {
      var today = new Date();

      var mToday = moment(today);

      var month = mToday.month();
      var year = mToday.year();

      var startDate = month + '/' + 21 + '/' + year;

      return startDate;
    },
    getEndDate: function getEndDate() {
      var today = new Date();

      var mToday = moment(today);

      var month = mToday.month() + 1;
      var year = mToday.year();

      var endDate = month + '/' + 20 + '/' + year;

      return endDate;
    },
    sortList: function sortList(by) {
      /*
        Checks to see if what the user selected to sort by
        is the same as it's been. If it is, then we toggle the
        direction.
      */
      if (by == this.sortBy) {
        if (this.sortDirection == 'ASC') {
          this.sortDirection = 'DESC';
        } else {
          this.sortDirection = 'ASC';
        }
      }
      /*
        If the sort by is different we set the sort by to what the
        user selected and defualt the direction to 'ASC'
      */
      if (by != this.sortBy) {
        this.sortDirection = 'ASC';
        this.sortBy = by;
      }

      /*
        Switch by what the sort by is set to, and run the method
        to sort by that column.
      */
      switch (this.sortBy) {
        case 'name':
          this.sortListByName();
          break;
        case 'unit':
          this.sortListByUnitId();
          break;
        case 'type':
          this.sortListByPaymentType();
          break;
        case 'submitted':
          this.sortListBySubmittedAmount();
          break;
        case 'processed':
          this.sortListByProcessedAmount();
          break;
        case 'date':
          this.sortListByDate();
          break;
        case 'status':
          this.sortListByStatus();
          break;
      }
    },
    sortListByName: function sortListByName() {
      this.items.sort(function (a, b) {
        if (this.sortDirection == 'ASC') {
          return a.user.name == b.user.name ? 0 : a.user.name > b.user.name ? 1 : -1;
        }

        if (this.sortDirection == 'DESC') {
          return a.user.name == b.user.name ? 0 : a.user.name < b.user.name ? 1 : -1;
        }
      }.bind(this));
    },
    sortListByUnitId: function sortListByUnitId() {
      this.items.sort(function (a, b) {
        if (this.sortDirection == 'ASC') {
          return parseInt(a.user.unit_id) < parseInt(b.user.unit_id) ? 1 : -1;
        }

        if (this.sortDirection == 'DESC') {
          return parseInt(a.user.unit_id) > parseInt(b.user.unit_id) ? 1 : -1;
        }
      }.bind(this));
    },
    sortListByPaymentType: function sortListByPaymentType() {
      this.items.sort(function (a, b) {
        if (this.sortDirection == 'ASC') {
          return a.type == b.type ? 0 : a.type > b.type ? 1 : -1;
        }

        if (this.sortDirection == 'DESC') {
          return a.type == b.type ? 0 : a.type < b.type ? 1 : -1;
        }
      }.bind(this));
    },
    sortListBySubmittedAmount: function sortListBySubmittedAmount() {
      this.items.sort(function (a, b) {
        if (this.sortDirection == 'ASC') {
          return parseInt(a.amount) < parseInt(b.amount) ? 1 : -1;
        }

        if (this.sortDirection == 'DESC') {
          return parseInt(a.amount) > parseInt(b.amount) ? 1 : -1;
        }
      }.bind(this));
    },
    sortListByProcessedAmount: function sortListByProcessedAmount() {
      this.items.sort(function (a, b) {
        if (this.sortDirection == 'ASC') {
          return parseInt(a.amount) < parseInt(b.amount) ? 1 : -1;
        }

        if (this.sortDirection == 'DESC') {
          return parseInt(a.amount) > parseInt(b.amount) ? 1 : -1;
        }
      }.bind(this));
    },
    sortListByDate: function sortListByDate() {
      this.items.sort(function (a, b) {
        if (this.sortDirection == 'ASC') {
          return parseInt(a.created_at) < parseInt(b.created_at) ? 1 : -1;
        }

        if (this.sortDirection == 'DESC') {
          return parseInt(a.created_at) > parseInt(b.created_at) ? 1 : -1;
        }
      }.bind(this));
    },
    sortListByStatus: function sortListByStatus() {
      this.items.sort(function (a, b) {
        if (this.sortDirection == 'ASC') {
          return a.status == b.status ? 0 : a.status > b.status ? 1 : -1;
        }

        if (this.sortDirection == 'DESC') {
          return a.status == b.status ? 0 : a.status < b.status ? 1 : -1;
        }
      }.bind(this));
    },
    getReport: function getReport() {
      var _this2 = this;

      this.loading = false;
      axios.post("/prototype/reporting/online-payments", {
        type: this.reportId,
        table: this.reportTable,
        start_date: this.start_date,
        end_date: this.end_date
      }).then(function (response) {
        if (response.data) {
          _this2.items = response.data;
          _this2.loading = false;
        }
      }).catch(function (err) {
        return console.log(err);
      });
    },
    exportReport: function exportReport() {
      Event.$emit("export-report", {
        type: this.reportId,
        table: this.reportTable,
        start_date: this.start_date,
        end_date: this.end_date
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/reports/OnlinePaymentReport.vue
// module id = sHT8
// module chunks = 0 1